import { getSourceTokens } from './controller'

export const useSourceTokens = () => getSourceTokens()
